import { IBaseService } from '@/bundles/App/interfaces';
import AdClientToMapper from '@/bundles/Ad/mappers/AdClientToMapper';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import HttpTransport from '@/bundles/Http/transport/HttpTransport';
import { PaginationResponse } from '@/bundles/App/type';
import { IAdClient } from '@/bundles/Ad/interfaces';
import { ICreateAdClientDto, IUpdateAdClientDto } from '@/bundles/Ad/dto';

export default class AdClientService implements IBaseService<AdClientToMapper> {
  errorMapper: ErrorMapper;
  recordMapper: AdClientToMapper;
  transport: HttpTransport;

  constructor (props: IBaseService<AdClientToMapper>) {
    this.errorMapper = props.errorMapper;
    this.recordMapper = props.recordMapper!;
    this.transport = props.transport;
  }

  async getList (): Promise<PaginationResponse<IAdClient>> {
    try {
      const response = await this.transport.get('/ad-client');
      return {
        data: response.data.map((item: IAdClient) => this.recordMapper.mapToModel(item)),
        total: response.total,
      };
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async create (payload: ICreateAdClientDto) {
    try {
      await this.transport.post('/ad-client', payload);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async update (id: number, payload: IUpdateAdClientDto) {
    try {
      await this.transport.put(`/ad-client/${id}`, payload);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }
}
